<div class="panel-body ">
  <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
    <div class="panel-body ">
      <div class="row ">
        <div class="table-responsive" [class.scroll-hide-xy]="(civilCase.getServiceOfDocumentsList().length==0)">
          <table id="serviceOfDocuments-table" class="table table-condensed table-striped ">
            <thead>
              <tr>
                <th id="V068c">
                  <span class="field-code ">V068c json='name'</span>Party to Be Served
                </th>
                <th id="V145">
                  <span class="field-code ">V145 (V189d V230d) json='abstractRef#,abstractNumber, serviceTypeDesc'</span>Type of Served Document
                </th>
                <th id="V140">
                  <span class="field-code ">V140 json='issueDateTime'</span>Issued Date and Time
                </th>
                <th id="V142">
                  <span class="field-code ">V142 json='serviceReasonReturnedDesc'</span>Status of Service (Reason Returned)
                </th>
                <th id="V144">
                  <span class="field-code ">V144 json='serviceVehicleDesc'</span>Method of Service
                </th>
                <th id="V143">
                  <span class="field-code ">V143 json='serveDateTime'</span>Served on
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let serviceDocument of civilCase.getServiceOfDocumentsList(); let i = index">
                <td id="{{'civil-caseDetails-serviceDocuments-' + i + '-partyCode'}}">
                  {{civilCase.getPartyNameByPartyRef(serviceDocument.getPartyCode())}}
                </td>
                <td *ngIf="serviceDocument.getTypeOfServedDocumentForAbstracts(civilCase) === ''"
                 id="{{'civil-caseDetails-serviceDocuments-' + i + '-typeOfServedDocument'}}">
                  {{serviceDocument.getTypeOfServedDocument(civilCase)}}
                </td>
                <td *ngIf="serviceDocument.getTypeOfServedDocumentForAbstracts(civilCase) !== ''"
                 id="{{'civil-caseDetails-serviceDocuments-' + i + '-typeOfServedDocumentForAbstracts'}}">
                  {{serviceDocument.getTypeOfServedDocument(civilCase)}}
                  <br> on {{serviceDocument.getTypeOfServedDocumentForAbstracts(civilCase)}}
                </td>
                <td id="{{'civil-caseDetails-serviceDocuments-' + i + '-issuedOnDate'}}">
                  {{serviceDocument.getIssuedOnDate() | date:'MM/dd/yyyy'}} {{serviceDocument.getIssuedOnDate() | date:'hh:mm a'}}
                </td>
                <td id="{{'civil-caseDetails-serviceDocuments-' + i + '-statusOfService'}}">
                   {{serviceDocument.getStatusOfService()}}
                </td>
                <td id="{{'civil-caseDetails-serviceDocuments-' + i + '-methodOfService'}}">
                   {{serviceDocument.getMethodOfService()}}
                </td>
                <td id="{{'civil-caseDetails-serviceDocuments-' + i + '-servedOnDate'}}">
                   {{serviceDocument.getServedOnDate() | date:'MM/dd/yyyy'}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/service-documents/service-documents.component.html